import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const ConsentManagementSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<ContentLayout>
			{Array.from({ length: 4 }).map((_, index) => (
				<div
					// eslint-disable-next-line react/no-array-index-key
					key={index}
					className="px-4 py-6 mt-0! border-b border-(--border-subtlest)">
					<div className="flex justify-between mb-2">
						<div className="w-full">
							<GovSkeleton
								width={generateRandomNumber(60, 95) + '%'}
								height="24px"
								aria-label={t('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
								className="skeleton-brighter"
							/>
						</div>
						<GovSkeleton
							width="130px"
							height="22px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
							className="hidden! skeleton-brighter [ md:block! ]"
						/>
					</div>
					<GovSkeleton
						width="120px"
						height="22px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
						className="skeleton-brighter"
					/>
					<GovSkeleton
						width="70px"
						height="22px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
						className="mt-2! ml-2! skeleton-brighter"
					/>
					<GovSkeleton
						width="130px"
						height="22px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
						className="mt-2! skeleton-brighter [ md:hidden! ]"
					/>
				</div>
			))}
		</ContentLayout>
	);
};
